import { Instagram } from "lucide-react";

const TikTokIcon = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 1 1-2.59-2.59c.27 0 .53.04.77.12V9.4a6.4 6.4 0 0 0-.77-.05 6.33 6.33 0 1 0 6.33 6.33V9.01a7.72 7.72 0 0 0 4.52 1.45V7.37a4.24 4.24 0 0 1-3.11-1.55z" />
  </svg>
);

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-white/10 px-6 md:px-10 py-16">
    <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row justify-between gap-10">
      <div>
        <div className="flex items-center">
          <span className="wordmark text-2xl">Quantum Boas</span>
        </div>
        <p className="text-qbfg/50 mt-4 max-w-sm text-sm">
          High-end Boa constrictor genetics. Ethically bred, meticulously documented,
          shipped with lineage.
        </p>
      </div>
      <div className="flex gap-16 text-sm">
        <div className="flex flex-col gap-3">
          <span className="text-qbfg/40 uppercase tracking-[0.2em] text-xs mb-1">Explore</span>
          <a href="/shop" className="text-qbfg/70 hover:text-qbprimary transition-colors">Collection</a>
          <a href="/genetics" className="text-qbfg/70 hover:text-qbprimary transition-colors">Genetics</a>
          <a href="/social" className="text-qbfg/70 hover:text-qbprimary transition-colors">Media</a>
          <a href="/newsletter" className="text-qbfg/70 hover:text-qbprimary transition-colors">Newsletter</a>
        </div>
        <div className="flex flex-col gap-3">
          <span className="text-qbfg/40 uppercase tracking-[0.2em] text-xs mb-1">Contact</span>
          <a href="mailto:chrisharris@quantum-boas.com" data-testid="footer-email" className="text-qbfg/70 hover:text-qbprimary transition-colors">chrisharris@quantum-boas.com</a>
          <a href="tel:+17248144012" data-testid="footer-phone" className="text-qbfg/70 hover:text-qbprimary transition-colors">724-814-4012</a>
          <span className="text-qbfg/70">Live arrival guaranteed</span>
          <div className="flex items-center gap-3 mt-2">
            <a href="https://www.instagram.com/quantumboas" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram"
              className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-white/15 text-qbfg/70 hover:text-qbprimary hover:border-qbprimary transition-colors">
              <Instagram className="w-5 h-5" />
            </a>
            <a href="https://www.tiktok.com/@quantumboas" target="_blank" rel="noopener noreferrer" data-testid="footer-tiktok" aria-label="TikTok"
              className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-white/15 text-qbfg/70 hover:text-qbprimary hover:border-qbprimary transition-colors">
              <TikTokIcon className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div className="max-w-[1400px] mx-auto mt-14 pt-8 border-t border-white/5 flex justify-between text-xs text-qbfg/40">
      <span>© {new Date().getFullYear()} Quantum Boas</span>
      <span>Bred with intention.</span>
    </div>
  </footer>
);
